import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiMapPin, FiClock, FiUsers, FiAward, FiBookOpen, FiHome, FiPhone, FiMail, FiInfo, FiArrowRight, FiImage, FiPlay, FiShoppingCart, FiNavigation, FiHeart, FiTrendingUp, FiCoffee, FiGrid, FiMaximize2, FiFilter, FiSearch } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

class Gallery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedImage: null,
            isModalOpen: false,
            allImages: [],
            currentPage: 0,
            loading: false,
            hasMore: true,
            imagesPerPage: 12,
            searchTerm: '',
            selectedCategory: 'all'
        };
        
        // New image list from screen directory
        this.imageList = [
            "IMG_7825.jpg",
            "IMG_7830.jpg",
            "IMG_7856.jpg",
            "IMG_7865.jpg",
            "IMG_7869.jpg",
            "IMG_7876.jpg",
            "IMG_7878.jpg",
            "IMG_7885.jpg",
            "IMG_7886.jpg",
            "IMG_7917.jpg",
            "IMG_7922.jpg",
            "IMG_7949.jpg",
            "IMG_7952.jpg",
            "IMG_7954.jpg",
            "IMG_7972.jpg",
            "IMG_7976.jpg",
            "IMG_7983.jpg",
            "IMG_7985.jpg",
            "IMG_7989.jpg",
            "IMG_8001.jpg",
            "IMG_8028.jpg",
            "IMG_8047.jpg",
            "IMG_8048.jpg",
            "IMG_8051.jpg",
            "IMG_8052.jpg",
            "IMG_8059.jpg",
            "IMG_8071.jpg",
            "IMG_8087.jpg",
            "IMG_8135.jpg",
            "IMG_8141.jpg",
            "IMG_8176.jpg",
            "IMG_8195.jpg",
            "IMG_8198.jpg",
            "IMG_8204.jpg",
            "IMG_8222.jpg",
            "IMG_8223.jpg",
            "IMG_8224.jpg",
            "IMG_8225.jpg",
            "IMG_8226.jpg",
            "IMG_8228.jpg",
            "IMG_8229.jpg",
            "IMG_8230.jpg",
            "IMG_8309.jpg",
            "IMG_8311.jpg",
            "IMG_8342.jpg",
            "IMG_8347.jpg",
            "IMG_8352.jpg",
            "IMG_8355.jpg",
            "IMG_8360.jpg",
            "IMG_8373.jpg",
            "IMG_8376.jpg",
            "LINE_ALBUM_2025.5.18_250730_1.jpg",
            "LINE_ALBUM_2025.5.18_250730_3.jpg",
            "LINE_ALBUM_2025.7.15_250715_1.jpg",
            "LINE_ALBUM_2025.7.15_250715_2.jpg",
            "LINE_ALBUM_2025.7.15_250715_3.jpg",
            "LINE_ALBUM_2025.7.15_250715_5.jpg",
            "LINE_ALBUM_2025.7.15_250715_6.jpg",
            "LINE_ALBUM_2025.7.15_250715_18.jpg"
        ];

    }

    componentDidMount() {
        this.loadInitialImages();
        this.setupIntersectionObserver();
    }

    setupIntersectionObserver() {
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && this.state.hasMore && !this.state.loading) {
                        this.loadMoreImages();
                    }
                });
            },
            { threshold: 0.1 }
        );
    }

    loadInitialImages = () => {
        const initialImages = this.imageList.slice(0, this.state.imagesPerPage);
        this.setState({
            allImages: initialImages,
            currentPage: 1,
            hasMore: this.imageList.length > this.state.imagesPerPage
        });
    }

    loadMoreImages = () => {
        if (this.state.loading || !this.state.hasMore) return;

        this.setState({ loading: true });

        setTimeout(() => {
            const nextPage = this.state.currentPage + 1;
            const startIndex = this.state.currentPage * this.state.imagesPerPage;
            const endIndex = startIndex + this.state.imagesPerPage;
            const newImages = this.imageList.slice(startIndex, endIndex);

            this.setState(prevState => ({
                allImages: [...prevState.allImages, ...newImages],
                currentPage: nextPage,
                hasMore: endIndex < this.imageList.length,
                loading: false
            }));
        }, 500);
    }

    openModal = (imageSrc, imageAlt) => {
        this.setState({
            selectedImage: { src: imageSrc, alt: imageAlt },
            isModalOpen: true
        });
    }

    closeModal = () => {
        this.setState({
            selectedImage: null,
            isModalOpen: false
        });
    }

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    }

    handleCategoryChange = (category) => {
        this.setState({ selectedCategory: category });
    }

    getFilteredImages = () => {
        let filtered = this.state.allImages;
        
        if (this.state.searchTerm) {
            filtered = filtered.filter(image => 
                image.toLowerCase().includes(this.state.searchTerm.toLowerCase())
            );
        }

        if (this.state.selectedCategory !== 'all') {
            // Simple category filtering based on image names
            filtered = filtered.filter(image => {
                if (this.state.selectedCategory === 'exhibition') {
                    return image.includes('IMG_');
                } else if (this.state.selectedCategory === 'activity') {
                    return image.includes('LINE_ALBUM');
                }
                return true;
            });
        }

        return filtered;
    }

    renderGalleryItem = (imageName, index) => (
        <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="gallery-item" style={{
                position: 'relative',
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                backgroundColor: 'white'
            }}
            onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-5px)';
                e.target.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
            }}
            onClick={() => this.openModal(`/assets/images/singha/screen/${imageName}`, `ภาพ ${index + 1}`)}>
                
                <div className="image-container" style={{
                    position: 'relative',
                    width: '100%',
                    height: '250px',
                    overflow: 'hidden'
                }}>
                    <img 
                        src={`/assets/images/singha/screen/${imageName}`}
                        alt={`ภาพ ${index + 1}`}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                        }}
                        onLoad={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                        }}
                    />
                    <div className="image-overlay" style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',
                        display: 'flex',
                        alignItems: 'flex-end',
                        padding: '1rem'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.opacity = 1;
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.opacity = 0;
                    }}>
                        <div style={{
                            color: 'white',
                            textAlign: 'center',
                            width: '100%'
                        }}>
                            <FiMaximize2 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }} />
                            <p style={{ margin: 0, fontSize: '0.9rem' }}>คลิกเพื่อดูภาพเต็ม</p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    )

    render() {
        const filteredImages = this.getFilteredImages();

        return (
            <React.Fragment>
                <PageHelmet pageTitle='แกลเลอรี่' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/screen/IMG_7825.jpg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '60vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 className="hero-title" style={{
                                    color: 'white',
                                    fontSize: '4rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1.5rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                }}>
                                    แกลเลอรี่
                                </h1>
                                <p className="hero-subtitle" style={{
                                    color: 'white',
                                    fontSize: '1.5rem',
                                    opacity: 0.9,
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)',
                                    marginBottom: '2rem'
                                }}>
                                    ชมภาพบรรยากาศและกิจกรรมต่างๆ ภายในพิพิธภัณฑ์สิงห์ท่า
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Gallery Grid */}
                <div className="gallery-grid ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="gallery-header text-center mb-5">
                                    <h2 style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1rem'
                                    }}>
                                        ภาพรวมพิพิธภัณฑ์สิงห์ท่า
                                    </h2>
                                    <p style={{
                                        color: '#666',
                                        fontSize: '1.5rem',
                                        maxWidth: '800px',
                                        margin: '0 auto'
                                    }}>
                                        ชมภาพบรรยากาศและกิจกรรมต่างๆ ภายในพิพิธภัณฑ์สิงห์ท่า 
                                        ที่แสดงให้เห็นถึงประวัติศาสตร์และวิถีชีวิตของชุมชนสิงห์ท่า
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        {filteredImages.length > 0 ? (
                            <div className="row">
                                {filteredImages.map((name, index) => 
                                    this.renderGalleryItem(name, index)
                                )}
                            </div>
                        ) : (
                            <div className="text-center" style={{
                                padding: '4rem 2rem',
                                backgroundColor: 'white',
                                borderRadius: '20px',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                            }}>
                                <FiSearch style={{
                                    fontSize: '4rem',
                                    color: '#ccc',
                                    marginBottom: '1rem'
                                }} />
                                <h3 style={{
                                    color: '#666',
                                    marginBottom: '1rem'
                                }}>
                                    ไม่พบภาพที่ค้นหา
                                </h3>
                                <p style={{
                                    color: '#999',
                                    fontSize: '1.1rem'
                                }}>
                                    ลองเปลี่ยนคำค้นหาหรือหมวดหมู่
                                </p>
                            </div>
                        )}
                        
                        {/* Loading indicator */}
                        {this.state.loading && this.state.hasMore && (
                            <div className="text-center mt-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">กำลังโหลด...</span>
                                </div>
                                <p className="mt-3" style={{ color: '#666' }}>กำลังโหลดภาพเพิ่มเติม...</p>
                            </div>
                        )}
                        
                        {/* Intersection observer target */}
                        {this.state.hasMore && (
                            <div 
                                ref={el => {
                                    if (el && this.observer) {
                                        this.observer.observe(el);
                                    }
                                }}
                                style={{ height: '20px', margin: '20px 0' }}
                            />
                        )}
                    </div>
                </div>

                {/* Image Modal */}
                {this.state.isModalOpen && this.state.selectedImage && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.9)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: '2rem'
                    }}
                    onClick={this.closeModal}>
                        <div style={{
                            position: 'relative',
                            maxWidth: '90vw',
                            maxHeight: '90vh'
                        }}>
                            <img 
                                src={this.state.selectedImage.src} 
                                alt={this.state.selectedImage.alt}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                    borderRadius: '10px'
                                }}
                            />
                            <button 
                                onClick={this.closeModal}
                                style={{
                                    position: 'absolute',
                                    top: '-50px',
                                    right: '0',
                                    background: 'none',
                                    border: 'none',
                                    color: 'white',
                                    fontSize: '2rem',
                                    cursor: 'pointer',
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                ×
                            </button>
                        </div>
                    </div>
                )}

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                <Footer />
            </React.Fragment>
        );
    }
}

export default Gallery;

